// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ButtonContentLink_disabled__KWls3","inverse":"ButtonContentLink_inverse__gSzPE","default":"ButtonContentLink_default__MdHNp","small":"ButtonContentLink_small__UAkkf"};